import appStore from 'store'
import api from './api'
import { QUERY_TYPE, PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    symbolList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
    contactHistory: [],
    totalRealizedProfit: 0,
    totalFee: 0,
    orderBy: null,
    delVisible: false,
  },
  getters: {},
  mutations: {
    // setUserList(state, payload) {
    //   state.userList = payload.list.slice()
    //   state.totalCount = payload.totalCount
    // },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setDetailList(state, payload) {
      state.detailList = payload.list ? payload.list.slice() : []
      state.detailTotalCount = payload.totalCount
    },
    setCoinList(state, payload) {
      state.coinList = payload || []
    },
    setSymbolList(state, payload) {
      state.symbolList = payload || []
    },
    setContactHistory(state, payload) {
      state.contactHistory = payload.list.slice()
      state.totalCount = payload.totalCount
    },
    setContactHistoryInfo(state, payload) {
      state.totalRealizedProfit = payload ? payload.totalRealizedProfit : 0
      state.totalFee = payload ? payload.totalFee : 0
    },
    setOrderBy(state, payload) {
      state.orderBy = payload
    },
    setDelVisible(state, payload) {
      state.delVisible = payload
    },
  },
  actions: {
    getHistory({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getHistory(query).then((res) => {
        if (res.code == 0) {
          commit('setContactHistory', res.data)
        }
      })
    },
    getHistoryInfo({ commit }, data) {
      return api.getHistoryInfo(data).then((res) => {
        if (res.code == 0) {
          commit('setContactHistoryInfo', res.data)
        }
      })
    },
    exportExcel({ commit }, data) {
      return api.exportExcel(data).then((res) => {
        return res
      })
    },
    addRemark({ commit }, data) {
      return api.addRemark(data).then((res) => {
        return res
      })
    },

    getDetail({ commit }, data) {
      api.getDetail(data).then((res) => {
        if (res.code == 0) {
          commit('setDetailList', res.result)
        }
      })
    },
    getCoinList({ commit }, data) {
      api.getCoinList().then((res) => {
        if (res.code == 0) {
          commit('setCoinList', res.result)
        }
      })
    },
    getSymbolList({ commit }, data) {
      api.getSymbolList().then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
    delPositionId({ commit }, { positionId }) {
      api.delPositionId(positionId).then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
  },
}

appStore.registerModule('contractHistory', store)
